<template>
  <div class="ccui-goods-list-commodity">
    <el-table
      :data="tableDataList"
      @select-all="handleCheckAllChange"
      @selection-change="handleSelectionChange"
      @select="handleCheckChange"
      :row-style="rowClass"
      border
    >
      <el-table-column
        type="selection"
        width="auto"
        :resizable="false"
      /><!--复选框-->
      <el-table-column
        class-name="ccui-goods-list-commodity-table-header"
        min-width="100"
        label="商品"
        :resizable="false"
      >
        <template slot-scope="scope">
          <div class="clearfix">
            <div class="ccui-goods-list-commodity-table-body-left">
              {{ scope.row.index }}
            </div>
            <div class="ccui-goods-list-commodity-goods-image">
              <el-image
                class="ccui-goods-list-commodity-table-body-center"
                :src="scope.row.skuMainPic"
                fit="scale-down"
              >
              </el-image>
              <div
                class="ccui-goods-list-commodity-goods-status"
                v-if="scope.row.statusShow"
              >
                <div>{{ scope.row.statusName }}</div>
              </div>
            </div>

            <div class="ccui-goods-list-commodity-table-body-right">
              <div
                class="ccui-goods-list-commodity-table-body-right-item"
                @mouseenter="handleMouseEnter"
              >
                {{ scope.row.spuName }}
              </div>
              <div
                class="ccui-goods-list-commodity-table-body-right-item"
                @mouseenter="handleMouseEnter"
              >
                <span>品牌：{{ scope.row.brandName }}</span>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <template v-for="(table, index) in tableTheadOptions">
        <el-table-column
          v-if="table.checked"
          :key="index"
          :label="table.label"
          :width="allWidth[table.width]"
          :align="table.align || 'left'"
          :header-align="table.headerAlign || 'left'"
          :show-overflow-tooltip="true"
          :resizable="false"
        >
          <template slot-scope="scope">
            {{ scope.row[table.prop] }}
          </template>
        </el-table-column>
      </template>
      <el-table-column
        label="操作"
        :width="allWidth.operate"
        :resizable="false"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.approveStatus === 2">
            <div class="td-button">
              <el-button plain type="single-number">查看</el-button>
            </div>
            <div class="td-button">
              <el-button plain type="single-number">审批</el-button>
            </div>
          </div>
          <div v-else>
            <div class="td-button">
              <el-button plain type="single-number">查看</el-button>
            </div>
          </div>
        </template>
        <template v-slot:header>
          <div class="ccui-multifunctional-table-wrapper-operation">
            <span>操作</span>
            <el-popover
              placement="right"
              popper-class="ccui-multifunctional-table-wrapper_setting__popover"
              trigger="click"
            >
              <el-checkbox
                v-for="(e, i) in fixedTableThead"
                :key="i"
                :checked="e.checked"
                disabled
                class="ccui-popover-disabled"
                >{{ e.label }}</el-checkbox
              >
              <div class="ccui-popover-line"></div>
              <draggable :list="tableTheadOptions" class="ccui-draggable">
                <el-checkbox-group
                  v-for="(item, index) in tableTheadOptions"
                  v-model="item.checked"
                  :key="index"
                >
                  <el-checkbox
                    :label="item"
                    :checked="item.checked"
                    :title="item.label"
                    @change="handleUpdate(item, index)"
                    >{{ item.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </draggable>
              <i
                class="el-icon-s-tools ccui-multifunctional-table-wrapper_setting__icon"
                slot="reference"
              ></i>
            </el-popover>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { getStyle } from "ccui/lib/utils/dom";
export default {
  name: "goods-list",
  components: {
    draggable
  },
  data() {
    return {
      allWidth: {
        price: 80,
        state: 80,
        unit: 70,
        cate: 100,
        time: 90,
        operate: 90
      },
      selectedData: [],
      selectRow: [],
      selectData: [],
      statusArr: [""],
      fixedTableThead: [{ label: "商品", checked: true }],
      tableTheadOptions: [
        {
          label: "销售价",
          prop: "salePrice",
          width: "price",
          align: "right",
          headerAlign: "left",
          checked: true
        },
        {
          label: "店铺名称",
          prop: "shopName",
          width: "price",
          checked: true
        },
        {
          label: "商品分类",
          prop: "skuClassifyPath",
          width: "cate",
          checked: true
        },
        {
          label: "状态",
          prop: "approveStatusStr",
          width: "state",
          checked: true
        },
        {
          label: "申请时间",
          prop: "applyTime",
          width: "time",
          checked: true
        }
      ]
    };
  },
  props: ["selectShow", "dropShow", "tableDataList"],
  watch: {
    selectData(data) {
      this.selectRow = [];
      if (data.length > 0) {
        data.forEach((item, index) => {
          this.selectRow.push(this.tableDataList.indexOf(item));
        });
      }
    }
  },
  created() {
    this.getTableWidth();
  },
  methods: {
    getTableWidth() {
      let obj = {
        medium: {
          price: 100,
          state: 90,
          unit: 70,
          cate: 130,
          time: 100,
          operate: 90
        },
        large: {
          price: 140,
          state: 126,
          unit: 98,
          cate: 182,
          time: 140,
          operate: 126
        }
      };
      const bodyWidth = document.body.clientWidth;
      if (bodyWidth >= 1400 && bodyWidth < 1960) {
        this.allWidth = { ...this.allWidth, ...obj.medium };
      } else if (bodyWidth >= 1960) {
        this.allWidth = { ...this.allWidth, ...obj.large };
      }
    },
    handleCheckAllChange(val) {
      this.selectedData = val;
    },
    handleCheckChange(val) {
      this.selectedData = val;
    },
    handleSelectionChange(data) {
      this.selectData = data;
      this.$emit("selected", data);
    },
    handleUpdate(item, index) {
      for (let i = 0; i < this.tableTheadOptions.length; i++) {
        if (i === index) {
          this.tableTheadOptions.checked = !this.tableTheadOptions.checked;
        }
      }
    },
    handleMouseEnter(e) {
      let target = e.target;
      let text = target.innerText;
      const range = document.createRange();
      range.setStart(target, 0);
      range.setEnd(target, target.childNodes.length);
      const rangeWidth = range.getBoundingClientRect().width;
      const padding =
        (parseInt(getStyle(target, "paddingLeft"), 10) || 0) +
        (parseInt(getStyle(target, "paddingRight"), 10) || 0);

      if (
        rangeWidth + padding > target.offsetWidth ||
        target.scrollWidth > target.offsetWidth
      ) {
        target.setAttribute("title", text);
      } else {
        target.removeAttribute("title");
      }
    },
    rowClass({ row, rowIndex }) {
      if (this.selectRow.includes(rowIndex)) {
        return { "background-color": "rgba(255,232,195,1) " };
      }
    }
  }
};
</script>
